import React from 'react';
import PopupBase from '../base/PopupBase';
import CustomButton from '../../components/buttons/CustomButton';
import ModulePreview from './ModulePreview';
import { getCategoryLabel } from '../../pages/appointment/modules/appointmentModules';
import styles from './CreateEditAppointmentType.module.css';

/**
 * Prévia de um módulo na configuração dos tipos de atendimento: o que ele
 * registra e uma maquete do card como aparece na tela de atendimento.
 * `onAdd` (opcional) mostra o botão para adicionar direto daqui.
 */
const ModulePreviewPopup = ({ module, onAdd, onClose }) => {
    if (!module) return null;

    const content = (
        <div className={styles.preview}>
            <div className={styles.previewIntro}>
                <span className={styles.moduleCategory}>{getCategoryLabel(module.category)}</span>
                <span className={styles.previewText}>{module.details || module.description}</span>
            </div>
            <span className={styles.hint}>Exemplo ilustrativo de como o card aparece na tela de atendimento.</span>
            <div className={styles.previewCards}>
                <ModulePreview moduleKey={module.key} />
            </div>
        </div>
    );

    const footer = (
        <div className={styles.footer}>
            <CustomButton variant="outlined" style="secondary" label="Fechar" onClick={onClose} />
            {onAdd && (
                <CustomButton
                    variant="contained"
                    style="primary"
                    label="Adicionar ao atendimento"
                    onClick={() => { onAdd(module.key); onClose(); }}
                />
            )}
        </div>
    );

    return (
        <PopupBase
            Title={`Prévia: ${module.label}`}
            Content={content}
            Footer={footer}
            OnClose={onClose}
            maxWidth="sm"
        />
    );
};

export default ModulePreviewPopup;
